import axios from '@/util/basehttp';
import qs from 'qs';


const pre = "/course/sort"

const courseSort = {
  courseSortListPage(pageSize, limit, keyWord, subjectId) {
    return axios.get(pre + `/courseSortListPage`, {
      params:
        {
          pageSize: pageSize,
          limit: limit,
          keyWord: keyWord,
          subjectId: subjectId,
        }
    });
  },
  courseSortList() {
    return axios.get(pre + `/courseSortList`);
  },
  courseSortInfo(id) {
    return axios.get(pre + `/courseSortInfo`, {params: {id: id}});
  },
  courseSortSave(params) {
    return axios.post(pre + `/courseSortSave`, qs.stringify(params));
  },
  courseSortDelete(id) {
    return axios.delete(pre + `/courseSortDelete`, {params: {id: id}});
  },
}
export default courseSort;



// WEBPACK FOOTER //
// ./src/api/course/courseSort.js